<div class="modal-header">
  <h5 class="modal-title">Galería de Imágenes</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
  </button>
</div>

<div class="modal-body">
  <div [@loadedHeightAnimation]="'visible'" *ngIf="!isLoading" class="gallery-container">
    <div class="row">
      <ng-container *ngIf="imageList.length > 0">
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-3" *ngFor="let image of imageList">
          <div class="gallery-item" (click)="selectImage(image)" [class.selected]="selectedImageUri == image.FileUri">
            <div class="image-wrapper">
              <img [src]="getImageUrl(image)" [alt]="getImageAlt(image)" class="img-fluid gallery-image" loading="lazy">
            </div>
            <div class="image-info">
              <p class="image-name">{{ image.Title }}</p>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="imageList.length == 0">
        <div class="col mb-3">
          <div class="card text-center">
            <div class="card-body">
              <p class="card-title"><strong>No hay imágenes asociadas a este tipo de imagen</strong></p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="isLoading">
    <!--Loader-->
    <div class="loader">
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">
    Cancelar
  </button>
  <button type="button" class="btn btn-primary" [disabled]="!selectedImage" (click)="selectAndClose(selectedImage!)">
    Seleccionar Imagen
  </button>
</div>